// extracted by mini-css-extract-plugin
module.exports = {"smallCookieBanner":"CookieNotice_smallCookieBanner__iaLIW","cookieBanner":"CookieNotice_cookieBanner__Pewox","allCookies":"CookieNotice_allCookies__Tv2bz"};